import { useContext } from "react";
import { useParams } from "react-router-dom";
import Constants from "../Constants";
import usePfqAxios from "../hooks/usePfqAxios";
import AddCaseFormContext from "../contexts/AddCaseFormContext";
import { errorToast } from "../utils/toast";
import { useDispatch } from "react-redux";
import { removeCaseDataFiles } from "../redux/actions/fileUpload";
import { useSelector } from "react-redux";
import { getIn } from "formik";

export default function useCaseRecordDelete() {
    const { caseId } = useParams();
    const dispatch = useDispatch();

    const { putData } = usePfqAxios();
    const caseDataFiles = useSelector(state => state.fileUpload.caseDataFiles);

    const addCaseFormContext = useContext(AddCaseFormContext);
    const removePathFromBadRecords = addCaseFormContext?.removePathFromBadRecords;

    const removeFileRecords = async ({ filesToDelete, caseRecordType, data, skipFileKeyValidation = false }) => {
        try {
            const fileKeys = filesToDelete.map(file => {
                const fileKey = file.s3UrlPath || file.uniqueKey;
                if (!fileKey) {
                    console.error('Missing S3 path or unique key for file deletion', file);
                    throw new Error('Missing S3 Path');
                }
                return fileKey;
            });
            const payload = {
                caseId,
                fileKeys,
                caseRecordType: caseRecordType || null,
                data,
                skipFileKeyValidation
            }

            const response = await putData(Constants.ApiUrl.removeFileRecords, payload);
            if (!response?.success) {
                throw new Error('Delete operation failed');
            }
            removePathFromBadRecords?.(fileKeys);

            return response;
        } catch (error) {
            console.error('Error deleting file:', error);
            errorToast('Failed to remove file. Please try again later.');
            throw error;
        }
    };

    const handleFileRemove = async ({ formik, providerIndex = null, fileToRemove, filePath, removeData, skipFileKeyValidation = false }) => {
        let filesToRemove = Array.isArray(fileToRemove) ? fileToRemove : [fileToRemove];
        let filterCondition = file => file.s3UrlPath !== fileToRemove.s3UrlPath;
        let shouldCallAPI = true;
        if (providerIndex !== null) {
            dispatch(removeCaseDataFiles(filesToRemove));
            filterCondition = (_, idx) => idx !== providerIndex;
        } else if (caseDataFiles.get(fileToRemove.s3UrlPath)) {
            dispatch(removeCaseDataFiles(fileToRemove.s3UrlPath));
            shouldCallAPI = false;
        }


        if (filePath) {
            const currentFiles = getIn(formik.values, filePath) || [];
            let updatedArray = [];
            if(Array.isArray(currentFiles)){
                updatedArray = currentFiles.filter(filterCondition);
            }
            formik.setFieldValue(filePath, updatedArray);
        }
        if (!shouldCallAPI) return;
        try {
            await removeFileRecords({
                filesToDelete: filesToRemove,
                data: removeData,
                caseRecordType: fileToRemove?.metaData?.caseRecordType,
                skipFileKeyValidation
            });
        } catch {
            setTimeout(() => window.location.reload(), 1500);
        }
    };
  
    return {
        removeFileRecords,
        handleFileRemove,
    };
}
